module.exports = __webpack_public_path__ + "static/media/post_success.d8ff9594.png";